import { useTranslation } from 'react-i18next';
import Button from '@/components/atoms/Button';
import { usePublicState } from '@/store/slices/publicSlice';
import { useReportPeriod } from '@/store/slices/reportFiltersSlice';

export interface ExportBtnProps {
  useQueryHook: () => [
    (arg?: any) => any,
    { isLoading?: boolean; isFetching?: boolean } & Record<string, any>,
    ...any[],
  ];
  filters?: Record<string, any>;
  params?: Record<string, any>;
  searchKey?: string;
  buttonText?: string;
  className?: string;
}

export default function ExportBtn({
  useQueryHook,
  filters,
  params,
  searchKey = 'search',
  buttonText,
  className,
}: ExportBtnProps) {
  const { t } = useTranslation();
  const [getReport, { isLoading, isFetching }] = useQueryHook();
  const { search } = usePublicState();

  const handleDownloadReport = async () => {
    const cleanParams: Record<string, any> = {};

    // 1. Search
    const activeSearch =
      filters?.search || (searchKey ? search?.[searchKey] : search?.search);
    if (activeSearch && String(activeSearch).trim()) {
      cleanParams.search = String(activeSearch).trim();
    }

    // 2. Date range
    const dateFrom = filters?.dateFrom || filters?.fromDate;
    if (dateFrom && String(dateFrom).trim()) {
      cleanParams.dateFrom = String(dateFrom).trim();
    }

    const dateTo = filters?.dateTo || filters?.toDate;
    if (dateTo && String(dateTo).trim()) {
      cleanParams.dateTo = String(dateTo).trim();
    }

    console.log('ddddddd', filters);

    // 3. Order Method
    const rawOrderMethod =
      filters?.orderMethod ??
      filters?.methods ??
      filters?.method ??
      filters?.status;
    if (rawOrderMethod) {
      if (Array.isArray(rawOrderMethod) && rawOrderMethod.length > 0) {
        cleanParams.orderMethod = rawOrderMethod.join(',');
      } else if (typeof rawOrderMethod === 'string' && rawOrderMethod.trim()) {
        cleanParams.orderMethod = rawOrderMethod.trim();
      }
    }

    // 4. Any other custom filter keys
    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (
          ![
            'page',
            'limit',
            'fromDate',
            'toDate',
            'dateFrom',
            'dateTo',
            'methods',
            'method',
            'status',
            'orderMethod',
            'search',
          ].includes(key)
        ) {
          const val = filters[key];
          if (val !== undefined && val !== null && val !== '') {
            cleanParams[key] = val;
          }
        }
      });
    }

    // 5. Additional params if specified
    if (params) {
      Object.assign(cleanParams, params);
    }

    await getReport({ params: cleanParams });
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleDownloadReport}
      loading={isLoading || isFetching}
      disabled={isLoading || isFetching}
      className={className}
    >
      {buttonText || t('reports.exportPdf', 'Export as PDF')}
    </Button>
  );
}
